/* eslint-disable import/prefer-default-export */
import { SxProps } from '@mui/material/styles';

export const sxs = <Theme extends object = Record<string, unknown>>(
    inputSxs: SxProps<Theme>[],
): SxProps<Theme> => inputSxs.flatMap((inputSx) => (Array.isArray(inputSx) ? inputSx : [inputSx]));
